export default function Navbar() {
  return (
    <nav style={{ padding: "15px", background: "#333", color: "white" }}>
      <h2>Contact Management</h2>
    </nav>
  );
}
